<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="swatchMainCategory({ mainCategoryId: '', categoryName: '全部' })"
              :class="{ 'selected': mainCategoryProductInfo.conditions.mainCategoryId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in mainCategoryProductInfo.mainCategorys"
              :key="index" @click="swatchMainCategory(item)"
              :class="{ 'selected': mainCategoryProductInfo.conditions.mainCategoryId == item.mainCategoryId }">
              {{ item.categoryName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('mainCategoryProduct.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input :placeholder="$t('mainCategoryProduct.inputName')"
                v-model="mainCategoryProductInfo.conditions.productName">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="_queryMainCategoryProductMethod()">
                {{ $t('mainCategoryProduct.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('mainCategoryProduct.specialProduct') }}</span>
            <el-button type="primary" size="small" style="float: right;" @click="_openAddMainCategoryProductModal()">
              {{ $t('mainCategoryProduct.add') }}
            </el-button>
          </div>
          <el-table :data="mainCategoryProductInfo.mainCategoryProducts" style="width: 100%">
            <el-table-column prop="categoryName" :label="$t('mainCategoryProduct.category')" align="center">
            </el-table-column>
            <el-table-column prop="productId" :label="$t('mainCategoryProduct.code')" align="center">
            </el-table-column>
            <el-table-column prop="productName" :label="$t('mainCategoryProduct.name')" align="center">
            </el-table-column>
            <el-table-column :label="$t('mainCategoryProduct.startTime')" align="center">
              <template slot-scope="scope">
                {{ _formatTime(scope.row.startTime) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('mainCategoryProduct.endTime')" align="center">
              <template slot-scope="scope">
                {{ _formatTime(scope.row.endTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="seq" :label="$t('mainCategoryProduct.sort')" align="center">
            </el-table-column>
            <el-table-column :label="$t('mainCategoryProduct.operation')" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openEditMainCategoryProductModel(scope.row)">
                  {{ $t('mainCategoryProduct.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteMainCategoryProductModel(scope.row)">
                  {{ $t('mainCategoryProduct.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="mainCategoryProductInfo.conditions.page"
            :page-size="mainCategoryProductInfo.conditions.row" layout="total, prev, pager, next"
            :total="mainCategoryProductInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-main-category-product ref="addMainCategoryProduct" @refresh="_listMainCategoryProducts"></add-main-category-product>
    <edit-main-category-product ref="editMainCategoryProduct" @refresh="_listMainCategoryProducts"></edit-main-category-product>
    <delete-main-category-product ref="deleteMainCategoryProduct" @refresh="_listMainCategoryProducts"></delete-main-category-product>
  </div>
</template>

<script>
import { queryMainCategoryProduct, queryMainCategory } from '@/api/admin/mainCategoryProduct/mainCategoryProductApi'
import AddMainCategoryProduct from '@/components/admin/addMainCategoryProduct/addMainCategoryProduct'
import EditMainCategoryProduct from '@/components/admin/editMainCategoryProduct/editMainCategoryProduct'
import DeleteMainCategoryProduct from '@/components/admin/deleteMainCategoryProduct/deleteMainCategoryProduct'

/**
 * 专区商品管理页面
 * 2026-07-03 改造：
 * 1. 记录当前选中的专区对象，用于新增商品时传递匹配规则
 * 2. 选择"全部"时禁止新增商品，提示先选择具体专区
 */
export default {
  name: 'MainCategoryProduct',
  components: {
    AddMainCategoryProduct,
    EditMainCategoryProduct,
    DeleteMainCategoryProduct
  },
  data() {
    return {
      mainCategoryProductInfo: {
        mainCategoryProducts: [],
        total: 0,
        records: 1,
        moreCondition: false,
        mcProductId: '',
        mainCategorys: [],
        conditions: {
          page: 1,
          row: 10,
          mainCategoryId: '',
          productId: '',
          productName: '',
          state: ''
        }
      },
      // 2026-07-03 新增：当前选中的专区对象
      currentCategory: null
    }
  },
  created() {
    this._listMainCategoryProducts()
    this._listMainCategorys()
  },
  methods: {
    handleCurrentChange(val) {
      this.mainCategoryProductInfo.conditions.page = val
      this._listMainCategoryProducts()
    },
    async _listMainCategoryProducts() {
      try {
        const res = await queryMainCategoryProduct(this.mainCategoryProductInfo.conditions)
        this.mainCategoryProductInfo.total = res.total
        this.mainCategoryProductInfo.records = res.records
        this.mainCategoryProductInfo.mainCategoryProducts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _listMainCategorys() {
      try {
        const res = await queryMainCategory({ page: 1, row: 100 })
        this.mainCategoryProductInfo.mainCategorys = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    /**
     * 打开新增专区商品弹窗
     * 2026-07-03 改造：必须选择具体专区，并传入专区匹配规则
     */
    _openAddMainCategoryProductModal() {
      if (!this.currentCategory || !this.currentCategory.mainCategoryId) {
        this.$message.warning('请先选择左侧具体专区，再添加商品')
        return
      }
      this.$refs.addMainCategoryProduct.open(this.currentCategory)
    },
    _openEditMainCategoryProductModel(row) {
      this.$refs.editMainCategoryProduct.open(row)
    },
    _openDeleteMainCategoryProductModel(row) {
      this.$refs.deleteMainCategoryProduct.open(row)
    },
    _queryMainCategoryProductMethod() {
      this.mainCategoryProductInfo.conditions.page = 1
      this._listMainCategoryProducts()
    },
    /**
     * 格式化时间显示
     * 2026-07-03 新增：兼容 ISO 格式（含 T）和普通格式
     */
    _formatTime(time) {
      if (!time) return ''
      return String(time).replace('T', ' ').substring(0, 19)
    },
    /**
     * 切换专区
     * 2026-07-03 改造：同时记录当前选中的专区对象
     */
    swatchMainCategory(category) {
      this.mainCategoryProductInfo.conditions.mainCategoryId = category.mainCategoryId
      // 当选择"全部"时，currentCategory 置为 null
      this.currentCategory = category.mainCategoryId ? category : null
      this._listMainCategoryProducts()
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

/* 使用全局 list-selector 样式，无需自定义样式 */
</style>
